import React, { memo, useEffect, useRef } from "react";
import { Checkbox, Typography } from "antd";

const QueryBodyItem = ({
  columnName,
  tableName,
  isChecked,
  onBodyCheckChange,
  showColumnExtra,
  index,
  classes,
  columnExtraFn,
  customColStyle,
  config,
  hideUnselectedCheckbox = false,
  listRef
}: any) => {

  const itemRef = useRef<HTMLLIElement>(null);
  useEffect(() => {
    // Add this element to the listRef array
    if (listRef && itemRef.current) {
      listRef.current[index] = itemRef.current;
    }
  }, [listRef, index]);

  let shouldShowCheckbox = true;

  if (!config?.columnCheckbox) {
    // If column checkboxes are disabled globally, hide all checkboxes
    shouldShowCheckbox = false;
  } else if (hideUnselectedCheckbox && !isChecked) {
    // If we're hiding unselected checkboxes AND this column is not checked, hide it
    shouldShowCheckbox = false;
  }

  return (
    <li
      ref={itemRef}
      className={`query-node-body-item ${isChecked ? "body-item-checked" : ""} ${customColStyle}`}
      onClick={(e) => {
        if (!hideUnselectedCheckbox) {
          const target = e.target as HTMLElement;
          if (!target.closest(".ant-checkbox")) {
            onBodyCheckChange(columnName, tableName, !isChecked);
          }
        }
      }}
    >
      <Typography.Text className="query-node-body-item-content">
        {columnName}
      </Typography.Text>
      <div className="node-body-extra-wrapper">
        {showColumnExtra && columnExtraFn && (
          <div>{columnExtraFn(columnName, tableName, index)}</div>
        )}
        <Checkbox
          className={`query-node-body-checkbox ${classes?.columnCheck || ""} ${shouldShowCheckbox ? "visible-checkbox" : "hidden-checkbox"}`}
          onChange={(e) =>
            hideUnselectedCheckbox ? null : onBodyCheckChange(columnName, tableName, e.target.checked)
          }
          checked={isChecked}
          disabled={hideUnselectedCheckbox}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              onBodyCheckChange(columnName, tableName, !isChecked);
            }
          }}
          title={hideUnselectedCheckbox ? "Selection disabled" : isChecked ? "Deselect column" : "Select Column"}
        />
      </div>
    </li>
  );
};

export default memo(QueryBodyItem);
